import { RootState } from "store/types";

export const selectProjectFormState = (state: RootState) => state.projects.projectForm;
